<!--
발송실패(설정) 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">

            <!-- stepper -->
            <div class="uk-modal-header">
                <div class="stepper">
                    <div
                        class="step"
                        :class="step1Class"
                    >
                        <div class="circle">1</div>
                        <div class="label">실패사유 작성</div>
                    </div>
                    <div class="divider"></div>
                    <div
                        class="step"
                        :class="step2Class"
                    >
                        <div class="circle">2</div>
                        <div class="label">상품 갖다놓기</div>
                    </div>
                </div>
            </div>


            <div class="uk-modal-body uk-padding-small">
                <!-- 사유작성 -->
                <div v-show="currStep === 1">
                    <div class="uk-text-large">
                        <i class="material-icons md-36">comment</i>
                        실패사유
                    </div>
                    <app-input-ex
                        class="uk-margin-bottom "
                        type="textarea"
                        :textarea-rows="5"
                        input-size="large"

                        name="memo"
                        v-model="jobMemo"
                        label=""

                        required-layout="label-left"

                        placeholder="발송작업 실패의 내용을 구체적으로 작성하세요"
                    > </app-input-ex>

                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-default uk-button-large2 uk-modal-close"
                        >
                            <span uk-icon="icon: close"></span> 취소
                        </button>

                        <button
                            type="button"
                            class="uk-button uk-button-danger uk-button-large2"
                            v-on:click="submit"
                        >
                            <span uk-icon="icon: check"></span>
                            완료(발송실패)
                        </button>
                    </div>

                </div>

                <!-- 보관처리 -->
                <div v-if="currStep === 2">
                    <div class="uk-text-large uk-text-center uk-margin-bottom uk-text-danger">
                        발송실패시, 반드시 상품 이미지를 촬영하여 <span class="uk-text-bold">상품상세 > 첨부파일</span>에 등록해 주세요.
                    </div>


                    <div class="uk-text-center uk-margin-bottom">
                        <button
                            type="button"
                            class="uk-button uk-button-white uk-button-large"
                            onclick="$.app.on_event.move(arguments);"
                            :data-url="'/prods/'+realProd.id"
                            data-target="_blank"
                        >
                            <i class="material-icons">link</i>
                            상품상세
                        </button>
                    </div>

                    <div class="uk-text-large uk-text-center uk-margin-bottom">
                        상품을 다시 보관장소에 갖다놓으세요
                    </div>

                    <div class="uk-text-large3 uk-text-center uk-margin-bottom uk-text-primary">
                        {{ storage }}
                    </div>




                    <div class="uk-text-right">
                        <button
                            type="button"
                            class="uk-button uk-button-black uk-button-large2 uk-modal-close"
                        >
                            <i class="material-icons">check</i>
                            완료
                        </button>
                    </div>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            // csrf-token
            csrfToken: String,

            // 발송요청
            req: Object,

            // 배송상품
            shipProd: Object,

            // 재고상품
            stockProd: Object,

            // 목록 url
            listUrl: {
                type: String,
                default: null,
            },

        },
        data: function () {
            return {
                /**
                 * (string) 작업메모
                 */
                jobMemo: null,

                /**
                 * (int) 진행단계
                 *       1~3
                 **/
                currStep: 1,

                // (bool) 모달창 종료이벤트 등록된적있는지 플래그값, 창 여러번 켜고 닫을때, 이벤트 한번만 등록되기 위함
                hasModalCloseEvent: false,
            };
        },
        computed: {
            // 스텝1 클래스계산
            step1Class: function () {
                let step = 1;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },
            // 스텝2 클래스계산
            step2Class: function () {
                let step = 2;

                return {
                    complete: this.currStep > step,
                    active: this.currStep === step,
                };
            },

            /**
             * 작업자의 눈앞에있는 실물 상품을 결정함
             * @return object
             */
            realProd() {
                if (this.stockProd) {
                    return this.stockProd;
                }
                return this.shipProd;
            },

            /**
             * 실물상품의 보관장소
             * @return string
             */
            storage() {
                if (this.realProd) {
                    return this.realProd.storage;
                }
                return null;
            },
        },
        methods: {

            /**
             * 폼
             */
            form() {

                // 폼 띄우기
                UIkit.modal(this.$el).show();


                // 모달창 종료이벤트
                if (! this.hasModalCloseEvent) {
                    UIkit.util.on(this.$el, 'beforehide', () => {
                        //console.log('before');
                        this.close();

                    });

                    this.hasModalCloseEvent = true;
                }
            },




            /**
             * submit
             */
            submit() {
                // promise 생성
                let p = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/region-out-requests/' + this.req.id + '/fail',
                        data: {
                            '_token': this.csrfToken,
                            'job_memo': this.jobMemo,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                        error: function(jqXHR, textStatus, errorThrown) {
                            reject();
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                p.then((response) => {
                    this.currStep = 2;
                }).catch(() => {
                    // 오류인경우, 모달 종료
                    UIkit.modal(this.$el).hide();
                });
            },


            /**
             * 작업완료 (창 닫기했을때 실행되는 액션)
             */
            close() {
                // 첫번째 단계가 지났으면, 모든 작업이 완료됨.
                if (this.currStep > 1) {
                    // 리스트로 이동
                    if (this.listUrl) {
                        $.app.move(this.listUrl);
                    } else {
                        $.app.move('/regions/' + this.req.region_id + '/out-requests');
                    }

                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    /*
    stepper css
    https://codepen.io/shanejdonnelly/pen/wJqgQR?page=3
    */
    .stepper{
        clear: left;
        float: left;
        font-size: 1.5rem;
        margin: 10px;
    }

    .step{
        float: left;
    //    font-size: 15px;
        margin: 0 12px;
    }

    .divider{ border-bottom: 1px solid #cfcfcf; float: left; height: 12px; margin: 0 12px; width: 45px; }

    .circle{
        background: #cfcfcf;
        border-radius: 50%;
        color: #ffffff;
        float: left;
        height: 30px;
        line-height: 30px;
        text-align: center;
        width: 30px;
    }

    .label{ color: #cfcfcf; float: left; line-height: 24px; margin-left: 8px; }

    .active{
        .circle{ background: #0f7ae5; }
        .label{ color: #0f7ae5; font-weight: 400; }
    }

    .complete{
        .circle{
            background: #666;
        }
        .label{
            color: #666;
            text-decoration-line: line-through;
        }
    }
</style>